import { createElement, removeElement } from '../utils/domManager';
import '../polyfills/fullscreen';

/**
 * Studio Link button component
 * @returns {Object}
 */
const studioLinkButton = (url, options) => {
    const domElement = createElement('div', { title: 'Open Studio in new tab',
        className: `top-right-button studio-link-button ${!options.fullScreenButton.enabled ? 'studio-link-button-right' : ''}` });
    const textElement = createElement('span', { className: 'studio-link-text', innerHTML: 'Studio' });
    const iconElement = createElement('svg', { viewBox: '0 0 12 12', class: 'top-right-button-icon' });

    setIcon();

    /**
   * Sets icon element styles and content
   */
    function setIcon() {
        iconElement.innerHTML = `<path d="M10.0742 10.0742V6H11.25V10.0742C11.25 10.7305 10.7305 11.25 10.0742 11.25H1.92578C1.26953 11.25 0.75
            10.7305 0.75 10.0742V1.92578C0.75 1.26953 1.26953 0.75 1.92578 0.75H6V1.92578H1.92578V10.0742H10.0742ZM7.17578 
            0.75H11.25V4.82422H10.0742V2.74609L4.35938 8.46094L3.53906 7.64062L9.25391 1.92578H7.17578V0.75Z"/>`;
    }

    function onDomElementClick() {
        open(url);
    }

    function onContainerMouseEnter() {
        domElement.style.display = 'flex';
    }

    function onContainerMouseLeave() {
        domElement.style.display = 'none';
    }

    function addListeners(containerElement) {
        domElement.addEventListener('click', () =>
            onDomElementClick(containerElement)
        );
        containerElement.addEventListener('mouseenter', onContainerMouseEnter);
        containerElement.addEventListener('mouseleave', onContainerMouseLeave);
    }

    function removeListeners(containerElement) {
        domElement.removeEventListener('click', () =>
            onDomElementClick(containerElement)
        );
        containerElement.removeEventListener('mouseenter', onContainerMouseEnter);
        containerElement.removeEventListener('mouseleave', onContainerMouseLeave);
    }

    /**
   * Appends button (and icon) element in DOM and creates listeners
   */
    function render(containerElement) {
        containerElement.style.position = 'relative';
        containerElement.appendChild(domElement);
        domElement.appendChild(textElement);
        domElement.appendChild(iconElement);
        addListeners(containerElement);
    }

    function remove(containerElement) {
        removeElement(containerElement, domElement);
        removeListeners(containerElement);
    }

    return {
        render,
        remove
    };
};

export default studioLinkButton;
